module.exports = __webpack_public_path__ + "img/box_pro_seven_4.d53f3eba.jpg";